export default {"src":"/_next/static/media/360-icon.4956b1c5.svg","height":33,"width":72};